import type { HeroIn } from '../@types/Hero';
import Hero from '../models/hero';

declare const __STATIC_HERO__: HeroIn;

export const getHeroSettings = () => {
  if (process.env.SSR) {
    return Hero.parse(__STATIC_HERO__);
  }
  return Hero.parse(window.__STATIC_HERO__);
};
